import { useEffect } from 'react'
import { Slider, ColorPicker, Button } from 'components'
import Flex from 'components/priority/Flex/Flex'
import Text from 'components/priority/Text/Text'
import { useRecoilValue, useRecoilState } from 'recoil'
import { selectedItemAtom, itemSelector } from 'atoms'
import { useTranslation } from 'react-i18next'
import { DEFAULT_FONT_COLOR } from '@messenger/consts'

export const DropShadowDrawer = () => {
  const { t } = useTranslation()
  const selectedItem = useRecoilValue(selectedItemAtom)
  const boxShadow = useRecoilValue(
    itemSelector({ id: selectedItem, path: 'edits.boxShadow' }),
  )
  const [xOffset, setXOffset] = useRecoilState(
    itemSelector({ id: selectedItem, path: 'edits.dropShadow.xOffset' }),
  )
  const [yOffset, setYOffset] = useRecoilState(
    itemSelector({ id: selectedItem, path: 'edits.dropShadow.yOffset' }),
  )
  const [blur, setBlur] = useRecoilState(
    itemSelector({ id: selectedItem, path: 'edits.dropShadow.blur' }),
  )
  const [spread, setSpread] = useRecoilState(
    itemSelector({ id: selectedItem, path: 'edits.dropShadow.spread' }),
  )
  const [opacity, setOpacity] = useRecoilState(
    itemSelector({ id: selectedItem, path: 'edits.dropShadow.opacity' }),
  )
  const [color, setColor] = useRecoilState(
    itemSelector({ id: selectedItem, path: 'edits.dropShadow.color' }),
  )
  const feather = useRecoilValue(
    itemSelector({ id: selectedItem, path: 'edits.feather' }),
  )

  useEffect(() => {
    const shadow = boxShadow && boxShadow?.split(')')
    const [x, y, blurD, spreadD] =
      shadow && shadow?.[1] ? shadow[1].split('px') : [0, 0, 0, 0]
    if (!blur) setBlur(parseInt(blurD) || 0)
    if (!xOffset) setXOffset(parseInt(x) || 0)
    if (!yOffset) setYOffset(parseInt(y) || 0)
    if (!spread) setSpread(parseInt(spreadD) || 0)
    //eslint-disable-next-line
  }, [blur, xOffset, yOffset, spread, selectedItem])

  useEffect(() => {
    const noValidOpacity = opacity !== 0 && !opacity
    if (noValidOpacity) setOpacity(100)
    if (!color) setColor(DEFAULT_FONT_COLOR)
    //eslint-disable-next-line
  }, [opacity, color, selectedItem])

  const resetAll = () => {
    setBlur(0)
    setXOffset(0)
    setYOffset(0)
    setSpread(0)
    setOpacity(100)
    setColor(DEFAULT_FONT_COLOR)
  }

  return (
    <Flex column padding="0 12px" disabled={feather}>
      <Text>
        {t('editor.menus.properties.elements.dropShadow.offsetLRText')}
      </Text>
      <Slider
        sliderState={[xOffset, setXOffset]}
        min="-100"
        max="100"
        margin="0 0 20px"
        initialValue={0}
      />

      <Text>
        {t('editor.menus.properties.elements.dropShadow.offsetTBText')}
      </Text>
      <Slider
        sliderState={[yOffset, setYOffset]}
        min="-100"
        max="100"
        margin="0 0 20px"
        initialValue={0}
      />

      <Text>{t('editor.menus.properties.elements.dropShadow.blurText')}</Text>
      <Slider
        sliderState={[blur, setBlur]}
        min="0"
        max="100"
        margin="0 0 20px"
        initialValue={0}
      />

      <Text>{t('editor.menus.properties.elements.dropShadow.spreadText')}</Text>
      <Slider
        sliderState={[spread, setSpread]}
        min="0"
        max="100"
        margin="0 0 20px"
        initialValue={0}
      />

      <Text>
        {t('editor.menus.properties.elements.dropShadow.opacityText')}
      </Text>
      <Slider
        sliderState={[opacity, setOpacity]}
        min="0"
        max="100"
        margin="0 0 20px"
        initialValue={100}
      />
      {color && (
        <ColorPicker
          color={[color, setColor]}
          label={t('editor.menus.properties.elements.dropShadow.colorLabel')}
          margin="0 0 20px"
        />
      )}
      <Button margin="0 0 20px" onClick={() => resetAll()}>
        {t('editor.menus.properties.elements.dropShadow.resetAllButton')}
      </Button>
    </Flex>
  )
}

export default DropShadowDrawer
